import Vue from 'vue'
import Vuex from 'vuex'
import device from './modules/device'
import getters from './getter'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    device
  },
    getters
})
